import { createEvent } from 'effector';
import { type CreateOrderProps } from './CreateOrder';
import { openCreateOrderModal } from './lib';

export const createOrder = createEvent<CreateOrderProps>();

createOrder.watch(openCreateOrderModal);
